import React, { Component } from 'react'

import { Lock } from '../../components/Icons'
import { Wrap, Label, InputContainer, StyledInput, IconContainer, Button } from './styles'

class Password extends Component {
  constructor(props) {
    super(props)
    this.state = {
      text: 'toon',
      visible: false,
      type: 'password'
    }
  }

  handleClick() {
    if (!this.state.visible) {
      this.setState({ visible: true, type: 'text', text: 'verberg' })
    } else {
      this.setState({ visible: false, type: 'password', text: 'toon' })
    }
  }

  render() {
    const { label, value, handleChange, placeholder, name, icon, valid, dataKey } = this.props

    return (
      <Wrap>
        {label ? <Label>{label}</Label> : null}

        <InputContainer>
          <StyledInput
            data-key={dataKey}
            type={this.state.type}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            name={name}
            icon={icon}
            valid={valid}
          />

          {icon === 'lock' ? (
            <IconContainer>
              <Lock size="" />
            </IconContainer>
          ) : null}

          <Button onClick={this.handleClick.bind(this)}>{this.state.text}</Button>
        </InputContainer>
      </Wrap>
    )
  }
}

export default Password



// WEBPACK FOOTER //
// ./src/components/Input/Password.js